import { useCallback } from "react";
import { useSSE } from "hooks/useSSE";
import { useThrottledRefresh } from "hooks/useThrottledRefresh";
import { toast } from "sonner";
import { log } from "utils/logger";
import MonitorToast from "../components/MonitorToast";

export function useMonitorSSE({
    url,
    getBody,
    getHeaders,
    getDetalle,
    onRefresh,
    shouldRefresh,
    subscriptionKey,
    throttleMs = 15000,
}) {
    const { trigger, pendingCount, resetPendingCount } = useThrottledRefresh({
        ms: throttleMs,
        shouldRefresh,
        onRefresh,
    });

    const handleSSEMessage = useCallback(
        async (data, event) => {
            log.debug("📨 Evento recibido:", event.event);

            if (event.event === "conexion") {
                log.debug("🟢 SSE conectado");
                return;
            }

            if (event.event === "evento") {
                const { eventoId: gateESHistoId } = data;

                trigger();

                try {
                    const detalle = await getDetalle?.(gateESHistoId);
                    if (detalle) {
                        toast.custom(
                            (t) => <MonitorToast t={t} detalle={detalle} />,
                            { duration: 5000 }
                        );
                    }
                } catch (err) {
                    log.error("Error obteniendo detalle del evento SSE:", err);
                }

                return;
            }

            log.debug("📨 Evento sin handler:", event.event);
        },
        [trigger, getDetalle]
    );

    const sseState = useSSE({
        url,
        getBody,
        getHeaders,
        onMessage: handleSSEMessage,
        subscriptionKey,
    });

    return {
        ...sseState,
        nuevosEventos: pendingCount,
        resetNuevosEventos: resetPendingCount,
    };
}